<template>
   <div class="activitygallery">

      
      <div class="activitygallery__over">
            
         <flickity ref="flickity" :options="galleryOptions">
            <div class="activitygallery__img" v-for="img in activity.activityImages" :key="img">
               <div class="activitygallery__img-item" v-bind:style="{ background: 'url(' + img + ')' + 'no-repeat center center' }"></div>
            </div>
         </flickity>
         <div class="activitygallery__buttons">
            <div @click="previous()" class="flickity__prev">
               <svg viewBox="0 0 448 512">
                  <path d="M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"></path>
               </svg>
            </div>
            <div @click="next()" class="flickity__next">
               <svg viewBox="0 0 448 512">
                  <path d="M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"></path>
               </svg>
            </div>
         </div>

         <div class="activitygallery__close" @click="closeGallery">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
               <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
            </svg>
            <span>Close</span>
         </div>

      </div>
      <div class="activitygallery__under"></div>

   </div>
</template>

<script>
   import Flickity from 'vue-flickity';

   export default {
      name: 'activityGallery',
      props: ['activity'],
      components: {
         Flickity
      },

      data() {
         return {
            galleryOptions: {
               prevNextButtons: false,
               pageDots: false,
            },
         }
      },

      methods: {
         next() {
            this.$refs.flickity.next();
         },

         previous() {
            this.$refs.flickity.previous();
         },

         closeGallery: function(){
            this.$emit('is-gallery-active')
         },
      },
   }
</script>
